import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import RegisterForm from "./components/Auth/RegisterForm";
import LoginForm from "./components/Auth/LoginForm";
import AdminLayout from "./components/Admin/AdminLayout";
import Dashboard from "./components/Admin/Dashboard";
import UsuariosView from "./components/Usuarios/Usuariosviews";
import ProductsView from "./components/Admin/ProductView";
import PrivateRouteAdmin from "./components/Common/PrivateRouteAdmin";
import CatalogoPublico from "./components/Catalogo/CatalogoPublico";
import HomeBeneficios from "./components/Home/HomeBeneficios";
import RegisterConsumerForm from "./components/Auth/RegisterConsumerForm";
import AuthChoice from "./components/Auth/AuthChoice";
import QRAdminView from "./components/Admin/QRAdminView";
import ReviewsView from "./components/Admin/ReviewsView";
import PerfilUsuario from "./components/Profile/PerfilUsuario";
import PerfilNegocio from "./components/Profile/PerfilNegocio";
import BusinessProfileForm from "./components/Admin/BusinessProfileForm";
import GlobalFooter from "./components/Common/Footer/GlobalFooter";
import MainNavbar from "./components/Common/NavBar/MainNavbar";
import AppToastProvider from "./components/Common/Toast/AppToastProvider";
import PrivateRouteInternal from "./components/Common/PrivateRouteInternal";
import InternalLogin from "./components/Internal/InternalLogin";
import InternalDashboard from "./components/Internal/InternalDashboard";
import ComoFunciona from "./pages/ComoFunciona";
import Faq from "./pages/Faq";
import SumarMiNegocio from "./pages/SumarMiNegocio";
import InfoComercios from "./pages/InfoComercios";
import Planes from "./pages/Planes";
import ContactoComercios from "./pages/ContactoComercios";
import SobreNosotros from "./pages/SobreNosotros";
import PoliticaPrivacidad from "./pages/PoliticaPrivacidad";
import Terminos from "./pages/Terminos";
import CookiesPolicy from "./pages/CookiesPolicy";
import LandingNegocios from "./pages/LandingNegocios";

function AppRoutes() {
  const location = useLocation();
  const isInternalRoute = location.pathname.startsWith("/internal");

  return (
    <AppToastProvider>
      {!isInternalRoute && <MainNavbar />}
      <Routes>
        <Route path="/internal/login" element={<InternalLogin />} />
        <Route
          path="/internal/dashboard"
          element={
            <PrivateRouteInternal>
              <InternalDashboard />
            </PrivateRouteInternal>
          }
        />
        <Route path="/internal" element={<Navigate to="/internal/dashboard" replace />} />

        <Route path="/" element={<HomeBeneficios />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/register" element={<RegisterForm />} />
        <Route path="/register-consumer" element={<RegisterConsumerForm />} />
        <Route path="/auth-choice" element={<AuthChoice />} />
        <Route path="/my-benefits" element={<PerfilUsuario />} />

        <Route path="/catalogo/:slug" element={<CatalogoPublico />} />

        <Route path="/como-funciona" element={<ComoFunciona />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/sumar-mi-negocio" element={<SumarMiNegocio />} />
        <Route path="/landing" element={<LandingNegocios />} />
        <Route path="/comercios/informacion" element={<InfoComercios />} />
        <Route path="/planes" element={<Planes />} />
        <Route path="/contacto-comercios" element={<ContactoComercios />} />
        <Route path="/sobre-nosotros" element={<SobreNosotros />} />
        <Route path="/legal/privacidad" element={<PoliticaPrivacidad />} />
        <Route path="/legal/terminos" element={<Terminos />} />
        <Route path="/legal/cookies" element={<CookiesPolicy />} />

        <Route
          path="/admin/:slug"
          element={
            <PrivateRouteAdmin>
              <AdminLayout />
            </PrivateRouteAdmin>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="usuarios" element={<UsuariosView />} />
          <Route path="qrview" element={<QRAdminView />} />
          <Route path="productos" element={<ProductsView />} />
          <Route path="review" element={<ReviewsView />} />
          <Route path="perfil" element={<PerfilNegocio />} />
          <Route path="settings" element={<BusinessProfileForm />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!isInternalRoute && <GlobalFooter />}
    </AppToastProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
